module.exports = __webpack_public_path__ + "img/loop.1aad1c0c.svg";